import { BaseModel, convertToArrayModels, fillOwnProperties, registerModel } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'
import type { ResearchDemandFilterType } from './types'
import ResearchDemandFilterOption from './ResearchDemandFilterOption'

export default class ResearchDemandFilter extends BaseModel {
  static override constructorName = 'ResearchDemandFilter'

  name: string = ''
  type: ResearchDemandFilterType = 'search'
  title: string = ''
  placeholder: string = ''
  items: ResearchDemandFilterOption[] = []
  includes: string[] = []
  'range_min': number = 0
  'range_max': number = 0
  'range_step': number = 0

  constructor(data?: unknown) {
    super(data)
    if (!isUnknownObject(data)) return

    fillOwnProperties(this, data, ['items'])

    this.items = convertToArrayModels(data.items, ResearchDemandFilterOption)
  }
}

registerModel(ResearchDemandFilter)
